import React from 'react'
import SideBar from '../components/SideBar'
import DetailsHeaderBar from '../components/DetailsHeaderBar'
import DetailsTopBar from '../components/DetailsTopBar'
import { useLocation, useNavigate } from 'react-router-dom';
import TransactionHistory from '../components/TransactionHistory';

function AdvertisingAgentTransaction() {
    const location = useLocation();
    const agent = location.state?.agent;
    const navigate = useNavigate();

    if (!agent) {
        return <p style={{ padding: "30px" }}>No agent data available.</p>;
    }

    const tabs = [
        {key: "personal", label: "Personal Details", path: "/advertising-agent-details"},
        {key: "wallet", label: "Wallet Details", path: "/advertising-agent-wallet-details"},
        {key: "invitation", label: "Invitation Details", path: "/advertising-agent-invitation-details"},
        {key: "request", label: "Request Details", path: "/advertising-agent-request-history"},
    ]

    return (
        <div className="member-details-layout">
            <SideBar />
            <div className="member-details-main">
                <DetailsHeaderBar
                    title="Advertising Agent Details"
                    subtitle="Agent Commission Wallet Transaction History"
                    breadcrumbs={[
                        {label: "Home", path: "/dashboard"},
                        {label: "Manage Ads Agents", path: "/manage-advertising-agent"},
                        {label: "Transaction History"}
                    ]}
                />
                <DetailsTopBar
                    tabs={tabs}
                    activeTab="wallet"
                    agent={agent}
                />

                <TransactionHistory agent={agent} />
            </div>
        </div>
    )
}

export default AdvertisingAgentTransaction